<template>
  <div class="wrapper" id="openPlantfromWap">

    <nav class="navbar navbar-default">
      <div class="container-fluid">

        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="#"><img src="../../../static/images/openPlatform/logo.png" alt=""></a>
        </div>


        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav">
            <li class="active"><a href="#" class="indexLink">首页</a></li>
            <li><a href="#" class="insurScenLink">保险场景</a></li>
            <li><a href="#">接入方式</a></li>
            <li><a href="#">技术支持</a></li>
          </ul>

          <ul class="nav navbar-nav navbar-right">
            <li><a href="#" class="loginLink">登录</a></li>
            <li><a class="registerLink">注册</a></li>
          </ul>
        </div>
      </div>
    </nav>

    <main class="contentModule">
      <transition name="router-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
    <div class="footer">
       <div class="top">
        <div class="left">
          <div class="content">
            <p><img class="teamwork" src="../../../static/images/openPlatform/teamwork.png" alt=""><span class="labelT">合作及咨询：</span><span>020-62324288 转 247</span></p>
            <p><img class="email" src="../../../static/images/openPlatform/email.png" alt=""><span class="labelT">合作邮箱：</span><span>open@xiaobaibao.com</span></p>
            <p><img class="wechat" src="../../../static/images/openPlatform/wechat.png" alt=""><span class="labelT">在线咨询：</span><span><a href="#">联系客服</a></span></p>
          </div>
        </div>
        <div class="right">
          <div class="content">
            <div class="one">
              <img class="zhengxun" src="../../../static/images/openPlatform/zhengxun.png" alt="">
              <p class="QRcodeTitle">正迅保险经纪公众号</p>
            </div>
            <div class="two">
              <img class="xiaobai" src="../../../static/images/openPlatform/xiaobai.png" alt="">
              <p class="QRcodeTitle">小白保险公众号</p>
            </div>
          </div>
        </div>
      </div>
      <p class="bottom">
        <span>粤ICP备13035223号-3</span>
        <span>Copyright&copy;广州米兔网络科技有限公司</span>
        <span>保险服务由正迅保险经纪有限公司提供</span>
      </p>
    </div>
  </div>
</template>

<script>

    export default {
        name: "openPlantfromWap",
        data() {
            return {
                current: 'index',
                name: '',
                styleShow: "display:block",
                styleShowTwo: "display:none",
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
  @import "../../../static/css/openPlatform/index.css";
  @import "../../../static/css/openPlatform/bootstrap.min.css";
  @import "../../../static/css/openPlatform/login.css";
  .el-menu.el-menu--horizontal{
    border-bottom: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/openPlatform/openPlantfromWap.vue